export default {
  running: false,
  start: function(setProgress) {
    if (!this.running) {
      this.running = true;
      let progress = 0;
      const interval = setInterval(
        () => {
          progress += 5;
          setProgress(progress);
          (progress >= 100) && clearInterval(interval);
        },
        300
      );
    }
  }
};